import React from 'react';
import { OfferSection } from './OfferSection';
export function FinalOfferSection() {
  return <section className="py-16 px-4 bg-[#F0F4EC] border-t border-[#E8DFD0] relative overflow-hidden" data-id="element-133">
      {/* Glow effect */}
      <div className="absolute bottom-0 left-0 w-full h-[300px] bg-[#2D5A3D] opacity-[0.05] blur-[80px] pointer-events-none" data-id="element-134"></div>

      <div className="max-w-[600px] mx-auto relative z-10" data-id="element-135">
        <div className="space-y-8 mb-12 text-left text-[#5C4A3A]" data-id="element-136">
          <div className="bg-white p-8 rounded-xl border border-[#E8DFD0] shadow-sm" data-id="element-137">
            <h4 className="text-[#2C1810] font-serif font-bold text-xl mb-4" data-id="element-138">
              Una Última Cosa...
            </h4>
            <p className="mb-4" data-id="element-139">
              Piensa en cómo te sentías hace 10 años. Esa energía. Esa claridad.
              Ese cuerpo que respondía.
            </p>
            <p className="mb-4" data-id="element-140">
              Eso no desapareció para siempre. Solo necesita que alguien te
              enseñe a encenderlo de nuevo.
            </p>
            <p className="font-bold text-[#2D5A3D] text-lg mb-4" data-id="element-141">
              El Manual de Sanación Natural es exactamente eso: El interruptor
              que vuelve a encender tu versión más vital.
            </p>
            <p className="text-[#2C1810] font-bold" data-id="element-142">
              Y hoy, por $6.97, es tuyo.
            </p>
          </div>
        </div>

        <OfferSection showUrgency={false} showCountdown={false} showGuarantee={false} showPayment={false} ctaText="🌿 SÍ — QUIERO RECUPERAR MI VITALIDAD AHORA →" data-id="element-143" />

        <div className="text-center mt-6 space-y-2" data-id="element-144">
          <p className="text-xs font-bold text-[#B91C1C] uppercase tracking-wide" data-id="element-145">
            Solo quedan 60 copias disponibles
          </p>
          <p className="text-xs text-[#5C4A3A]" data-id="element-146">
            🔒 Tu compra está 100% protegida por nuestra Garantía de 7 Días Sin
            Riesgo
          </p>
        </div>
      </div>
    </section>;
}